import { clsx } from 'clsx'

import { Icon } from './icon'

type LoaderProps = {
  size?: string
  containerFullWidth?: boolean
  className?: string
  displayLoadingText?: boolean
}
const Loader = ({ size = '64', displayLoadingText = true, containerFullWidth = true, className }: LoaderProps) => {
  return (
    <div
      className={clsx(
        'h-full flex flex-col justify-center items-center text-text-light dark:text-text-dark',
        containerFullWidth && 'w-full',
      )}
    >
      <div className='animate-spin '>
        <Icon name='Settings' size={parseInt(size)} className={clsx('text-primary', className)} />
      </div>
      {displayLoadingText && <span className='text-sm'>Ładowanie...</span>}
    </div>
  )
}

export default Loader
